import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import CrawlerTable from '@hydra/routes/crawler/components/CrawlerTable';
import TitleIssueRow from '../TitleIssueRow';

import FilterContainer from '@hydra/routes/crawler/components/FilterContainer';
import FilterCheckboxes from '@hydra/routes/crawler/components/FilterCheckboxes';
import FilterString from '@hydra/routes/crawler/components/FilterString';
import Order from '@hydra/routes/crawler/components/Order';
import { withFilters } from '@hydra/routes/crawler/components/withFilters';

export const TitleIssueTable = props => {
  const toggles = get(props.project, 'crawls.edges[0].node.countTypesTitleIssues', [])
    .map(v => ({ identifier: v.type, ...v }));

  return (
    <>
      <FilterContainer>
        <FilterCheckboxes
          onChange={props.onGraphQLCheckboxInputChange('typeFilters', toggles)}
          checkedItems={props.filters.typeFilters}
          groups={toggles}
          name='typeFilters'
          label={<Translate content='crawler_title_issues' />}
        />
        <FilterString
          onChange={props.onGraphQLInputChange('title')}
          value={props.filters.title}
          name='title'
          label={<Translate content='crawler_title_text' />}
        />
        <FilterString
          onChange={props.onGraphQLInputChange('url')}
          value={props.filters.url}
          name='url'
          label={<Translate content='crawler_error_page_url' />}
        />
      </FilterContainer>
      <CrawlerTable {...props} category='onpageCategory' section='titleIssues'>
        <CrawlerTable.TableHead>
          <Translate content='crawler_title_issues' size='2' />
          <Order
            size='2'
            onChange={props.onOrderChange('lenOrder')}
            order={props.order.lenOrder}
          >
            <Translate content='crawler_characters' />
          </Order>
          <Translate content='crawler_title_text' size='3' />
          <Translate content='crawler_error_page_url' size='5' />
        </CrawlerTable.TableHead>
        <CrawlerTable.Body component={TitleIssueRow} />
      </CrawlerTable>
    </>
  );
};

TitleIssueTable.propTypes = {
  project: PropTypes.object.isRequired
};

const WithFiltersTable = (withFilters)(TitleIssueTable);

export default createRefetchContainer(
  WithFiltersTable,
  {
    project: graphql`
    fragment TitleIssueTable_project on Project
    @argumentDefinitions(
      offset: {type: "Int", defaultValue: 0},
      limit: {type: "Int", defaultValue: 20},
      typeFilters: {type: "[String]", defaultValue: []},
      lenOrder: {type: "Int", defaultValue: 0},
      title: {type: "TextFilters", defaultValue: { operator: AND, values: [] }},
      url: {type: "TextFilters", defaultValue: { operator: AND, values: [] }}
    ) {
      host,
      crawls (offset: 0, limit: 1) {
        edges {
          node {
            countTypesTitleIssues(title: $title, url: $url) {
              type
              severity
              count
            },
            titleIssues(offset: $offset, limit: $limit, typeFilters: $typeFilters, url: $url, lenOrder: $lenOrder, title: $title) {
              count
              edges {
                node {
                  id
                  ...TitleIssueRow_issue
                }
              }
            }
          }
        }
      }
    }
  `
  },
  graphql`
      query TitleIssueTable_RefetchQuery($offset: Int, $limit: Int, $typeFilters: [String], $lenOrder: Int, $title: TextFilters, $url: TextFilters, $host: String!) {
        project (host: $host) {
          ...TitleIssueTable_project @arguments(
            offset: $offset,
            limit: $limit,
            typeFilters: $typeFilters,
            url: $url,
            lenOrder: $lenOrder,
            title: $title
          )
        }
      }
    `
);
